import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationLocale } from '../i18n';
import { I18n, I18nLocale } from '../models/Base';
import { getFromI18n, getUiLocale } from '../utils/i18n';

export interface LFunction {
  <R>(i18nInfo: I18n<R, I18nLocale>): NonNullable<R>;
  <R>(i18nInfo?: I18n<R, I18nLocale> | undefined): NonNullable<R> | undefined;
}

const useLocale = (locale?: TranslationLocale | I18nLocale): LFunction => {
  const { i18n } = useTranslation();

  const _locale = locale ?? getUiLocale(i18n.language as TranslationLocale);

  let i18nLocale: I18nLocale | undefined;
  switch (_locale) {
    case TranslationLocale.EN:
    case TranslationLocale.US:
    case TranslationLocale.HK:
    case TranslationLocale.ZH:
    case TranslationLocale.TW:
    case TranslationLocale.CN:
    case TranslationLocale.JP:
    case TranslationLocale.JA:
      i18nLocale = getUiLocale(_locale);
      break;
    default:
      i18nLocale = _locale;
  }

  return useCallback<LFunction>(
    (i18nInfo) => getFromI18n(i18nInfo, i18nLocale),
    [i18nLocale],
  );
};

export default useLocale;
